import React, { useState } from "react";
import { RiFilter3Line } from "react-icons/ri";
import { Container, FiltrosTitle, FormContainer } from "./styles";
import Text from "../../../../components/shared/Text";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { LineChart } from "../../../../components/Charts/Line";
import {
  SelectOptionsMock,
  mockCategories2,
  oneLineMockSeries,
} from "../../../../components/Charts/Line/chartDataMocks";

interface FilterState {
  uf: string;
  cidade: string;
  periodo: string;
  startDate: string;
  endDate: string;
}

const Panel = () => {
  const [selectedFilters, setSelectedFilters] = useState<FilterState>({
    uf: "",
    cidade: "",
    periodo: "",
    startDate: "",
    endDate: "",
  });

  const handleFilterChange =
    (filterName: keyof FilterState) => (event: SelectChangeEvent) => {
      setSelectedFilters((prevState) => ({
        ...prevState,
        [filterName]: event.target.value,
      }));
    };

  return (
    <Container>
      <FiltrosTitle>
        <RiFilter3Line />
        <Text as="p" size="large" weight="semibold" color="text">
          Filtros
        </Text>
      </FiltrosTitle>
      <FormContainer>
        <FormControl fullWidth size="small">
          <InputLabel id="uf-select-label">UF</InputLabel>
          <Select
            labelId="uf-select-label"
            id="uf-select"
            value={selectedFilters.uf}
            label="Selecione uma das opções"
            onChange={handleFilterChange("uf")}
          >
            <MenuItem value={10}>Acessos</MenuItem>
            <MenuItem value={20}>Agendamentos</MenuItem>
            <MenuItem value={30}>Atendimentos SSE</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth size="small">
          <InputLabel id="cidade-select-label">Cidade</InputLabel>
          <Select
            labelId="cidade-select-label"
            id="cidade-select"
            label="Selecione uma das opções"
            value={selectedFilters.cidade}
            onChange={handleFilterChange("cidade")}
          >
            <MenuItem value={10}>Acessos</MenuItem>
            <MenuItem value={20}>Agendamentos</MenuItem>
            <MenuItem value={30}>Atendimentos SSE</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth size="small">
          <InputLabel id="periodo-select-label">Período</InputLabel>
          <Select
            labelId="periodo-select-label"
            id="periodo-select"
            value={selectedFilters.periodo}
            label="Selecione uma das opções"
            onChange={handleFilterChange("periodo")}
          >
            <MenuItem value={10}>Acessos</MenuItem>
            <MenuItem value={20}>Agendamentos</MenuItem>
            <MenuItem value={30}>Atendimentos SSE</MenuItem>
          </Select>
        </FormControl>
      </FormContainer>
      <Grid
        container
        direction="row"
        rowSpacing={1}
        marginTop={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      >
        <Grid item xs={6}>
          <LineChart
            title="Total de Acessos"
            type="line"
            total={123}
            series={oneLineMockSeries}
            selectOptions={SelectOptionsMock}
            categories={mockCategories2}
          />
        </Grid>
        <Grid item xs={6}>
          <LineChart
            title="Usuários únicos"
            selectLabel="Filtros internos"
            selectOptions={SelectOptionsMock}
            type="line"
            total={3243242}
            series={oneLineMockSeries}
            categories={mockCategories2}
          />
        </Grid>
        <Grid item xs={6}>
          <LineChart
            title="Média por usuário"
            type="line"
            total={123}
            selectLabel="Filtros internos"
            selectOptions={SelectOptionsMock}
            series={oneLineMockSeries}
            categories={mockCategories2}
          />
        </Grid>
        <Grid item xs={6}>
          <LineChart
            title="Distribuição no dia"
            type="line"
            selectLabel="Filtros internos"
            selectOptions={SelectOptionsMock}
            total={3243242}
            series={oneLineMockSeries}
            categories={mockCategories2}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Panel;
